
import styled, { keyframes } from 'styled-components'

import COLORS from 'constants/colors'
import FONTS from 'constants/fonts'
import MEDIA from 'constants/media'

import { RadioOptionLabel } from './Option/styles'

import { Props } from './types'

const baseDiv = styled.div<Props>`
  border: ${(props): string =>
    (!props.valid && (props.touched || props.alwaysShowError) && `1px solid ${COLORS.ERROR}`) ||
    (!props.valid && props.value && `1px solid ${COLORS.WARNING}`) ||
    'none'};
  border-radius: 8px;
  padding: ${(props): string => (!props.valid && (props.touched || props.alwaysShowError) && '5px 10px') || '0'};
`

export const RadioWrapperVertical = styled(baseDiv)``

export const RadioWrapperHorizontal = styled(baseDiv)`
  display: flex;
  width: 100%;
  margin: 0;
  justify-content: space-between;
  flex-wrap: wrap;
  ${RadioOptionLabel} {
    margin-right: 5px;
    height: 60px;
    max-width: 60px;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    &:last-child {
      margin-right: 0;
    }
  }
  ${MEDIA.tiny`
    ${RadioOptionLabel} {
      height: 80px;
      max-width: 80px;
    }
  `}
  ${MEDIA.small`
    ${RadioOptionLabel} {
      height: 105px;
      max-width: 105px;
    }
  `}
`

export const Label = styled.span`
  color: ${COLORS.BLACK};
  display: block;
  padding-left: 10px;
  font-family: ${FONTS.FAMILYSECONDARY};
  font-weight: ${FONTS.WEIGHTDEMI};
  text-align: center;
  font-size: ${FONTS.FONTLABELMOBILE};
  cursor: pointer;
  ${MEDIA.medium`
    font-size: ${FONTS.FONTLABEL};
  `}
`

const animationKeyframes = keyframes`
  0% {
    width: 0;
    height: 0;
  }
  100% {
    width: 10px;
    height: 18px;
    transform: rotate(45deg);
    transform-origin: 0% 100%;
  }
`

export const Radio = styled.span.attrs<Props>(
  ({ isChecked }) => ({ className: isChecked ? 'isChecked' : '' }),
)<Props>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 30px;
  height: 30px;
  background: transparent;
  border: 4px solid ${COLORS.BLACK};
  border-radius: 2px;
  cursor: pointer;
  transition: all 250ms cubic-bezier(0.4, 0, 0.23, 1);
  &.isChecked {
    border: 4px solid ${COLORS.GREYMEDIUM};

    &:before {
      content: '';
      position: relative;
      top: -8px;
      left: -5px;
      border-right: 3px solid ${COLORS.BLACK};
      border-bottom: 3px solid ${COLORS.BLACK};
      animation: ${animationKeyframes} 0.25s cubic-bezier(0.4, 0, 0.23, 1) forwards;
    }
  }
`
